// extracted by mini-css-extract-plugin
export default {"IssuuPreview__button":"HNqsn14_a8Mp9lxR_0xH"};